<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit shift</span>
          <span v-else>Create a New shift</span>
        </h1>
        <span>
          <router-link :to="{ name: 'shifts' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div class="row">
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('name') },
                    ]"
                  >
                    <label class="required">Name</label>
                    <div class="form_input">
                      <input
                        type="name"
                        class="form_global"
                        v-model="form.name"
                      />
                      <v-errors :errors="errorFor('name')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_3">
                  <div
                    :class="['form_row_inline', { has_error: errorFor('key') }]"
                  >
                    <label class="required">Key</label>
                    <div class="form_input">
                      <input
                        type="key"
                        class="form_global"
                        v-model="form.key"
                      />
                      <v-errors :errors="errorFor('key')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_3">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('color') },
                    ]"
                  >
                    <label class="required">Color</label>
                    <div class="form_input">
                      <input
                        type="color"
                        class="form_global"
                        v-model="form.color"
                      />
                      <v-errors :errors="errorFor('color')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('start_time') },
                    ]"
                  >
                    <label class="required">Start time</label>
                    <div class="form_input">
                      <time-picker
                        v-model:input="form.start_time"
                      ></time-picker>
                      <v-errors :errors="errorFor('start_time')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('end_time') },
                    ]"
                  >
                    <label class="required">End time</label>
                    <div class="form_input">
                      <time-picker v-model:input="form.end_time"></time-picker>
                      <v-errors :errors="errorFor('end_time')"></v-errors>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col_6 pl_20">
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('description') },
                ]"
              >
                <label class="">Description</label>
                <div class="form_input">
                  <textarea
                    type="text"
                    class="form_global"
                    rows="5"
                    v-model="form.description"
                  ></textarea>
                  <v-errors :errors="errorFor('description')"></v-errors>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_6">
              <div class="form_row_inline">
                <label></label>
                <div class="form_input">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TimePicker from '@/components/shared/TimePicker';
export default {
  name: 'shift-form',
  components: { LoaderMaskComponent, TimePicker },
  data() {
    return {
      lyLoading: false,
      form: {
        name: '',
        key: '',
        color: '#000000',
        start_time: '',
        end_time: '',
        description: '',
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
  },
  computed: {
    duration() {
      if (this.form.start_time && this.form.end_time) {
        const startTime = new Date(`1970-01-01T${this.form.start_time}:00`);
        const endTime = new Date(`1970-01-01T${this.form.end_time}:00`);
        if (endTime > startTime) {
          const diff = (endTime - startTime) / (1000 * 60); // Convert milliseconds to minutes
          return diff;
        }
      }
      return 0;
    },
  },
  methods: {
    loadData(formId) {
      this.lyLoading = true;
      this.axios
        .get('/shifts/' + formId)
        .then((response) => {
          this.form = response.data.data;
        })
        .catch(() => {
          this.showFailMsg('No form exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/shifts', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('Shift Created Successfully!');
          this.$router.push({ name: 'shifts' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/shifts/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('Shift Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.form = {
        name: '',
        key: '',
        color: '#000000',
        start_time: '',
        end_time: '',
        description: '',
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
